import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { Position } from '@core/positions-and-skills-types';

import { EntityStoreKey } from './types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<Position>()(
  EntityStoreKey.Positions,
);

export {
  selectors as PositionsSelectors,
  actions as PositionsActions,
  reducer as PositionsReducer,
  namespace as PositionsNamespace,
};
